import { FormattedMessage, useIntl } from 'react-intl';

import type { FreightClass } from '@shipstation/client-common/types/ltl';

import { DropdownField } from 'ui-components/components/dropdown/dropdown-field';
import { Gap } from 'ui-components/components/flex';
import { FlexColumn } from 'ui-components/components/flex/column';
import { FlexRow } from 'ui-components/components/flex/row';
import { Input } from 'ui-components/components/input';
import { Text, TextType } from 'ui-components/components/text';

import { InputLabel } from '../../../../../../../../../address/input-label';
import { FREIGHT_CLASS_OPTIONS } from '../../../../../../../../../pages/ltl-freight/constants';
import style from '../../uom-modal.module.css';
import { messages } from './freight-section.messages';

export type FreightSectionProps = {
  freightClass: FreightClass | null;
  nmfcCode: string;
  onFreightClassChange: (value: FreightClass) => void;
  onNmfcCodeChange: (value: string) => void;
};

export const FreightSection = ({ freightClass, nmfcCode, onFreightClassChange, onNmfcCodeChange }: FreightSectionProps) => {
  const intl = useIntl();

  return (
    <>
      <div className={style['section-header']}>
        <Text className={style['section-label']} element='span' textType={TextType.Label} value={messages.freightSectionLabel} />
        <div className={style['section-rule']} />
      </div>

      <FlexRow className={style['flex-row']} gap={Gap.Space16}>
        <FlexColumn className={style['flex-column']}>
          <InputLabel>
            <FormattedMessage {...messages.freightClassLabel} />
          </InputLabel>
          <DropdownField
            ariaLabel={intl.formatMessage(messages.freightClassLabel)}
            className={style['freight-class-select']}
            onItemSelected={(value: string) => onFreightClassChange(value as FreightClass)}
            options={FREIGHT_CLASS_OPTIONS}
            selectedItemValue={freightClass ?? ''}
          />
        </FlexColumn>

        <FlexColumn className={style['flex-column']}>
          <InputLabel>
            <FormattedMessage {...messages.nmfcCodeLabel} />
          </InputLabel>
          <Input
            aria-label={intl.formatMessage(messages.nmfcCodeLabel)}
            className={style['nmfc-code-input']}
            maxLength={20}
            type='text'
            onChange={(v: string) => onNmfcCodeChange(v)}
            value={nmfcCode}
          />
        </FlexColumn>
      </FlexRow>
    </>
  );
};
